module.exports = "https://static.wagwalking.com/_next/static/images/pet-care-b768a235210da6d5d4881912b9d4cef7.svg";